import React from "react";
import { useSelector } from "react-redux";
import { LANDSCAPE } from "../../config/Constant";
import MyBill_Landscape from "./myBill_landscape";
import MyBill_Potrait from "./myBill_potrait";


export const MyBill = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    if (appOrientation == LANDSCAPE) {
        return <MyBill_Landscape {...props} />;
    } else {
        return <MyBill_Potrait {...props} />;
    }
}

